import {ServiceBase} from "../ServiceBase";
import {IAbTestingAiSortGamesListsService, } from "./ab-testing-ai-sort-games-lists.service.interface";

/*
 * Token structure for this feature:
 *
 * "AbTestingAiSortGamesLists": {
 *  "Properties": {
 *    "arenas": ["homePage", "slots"]
 *  }
 * }
 *
 */

export class AbTestingAiSortGamesListsService extends ServiceBase implements IAbTestingAiSortGamesListsService {

    public arenaHasAiSorting(arenaName: string): boolean {
        return this.services.abTestingFeatureDataProvider.aiSortGamesLists.arenas.indexOf(arenaName) !== -1;
    }
}
